import React, { createContext, useContext, useState } from "react";

const LiquidacionesContext = createContext();

export function LiquidacionesProvider({ children }) {
  const [state, setState] = useState({
    liquidacionRows: [],
    selectedLiquidacionRows: [],
    listasHonorariosRows: [],
    listasActivas: true,
    selectedListasHonorariosRows: [],
    liquidandoNombre: null,
    loadingRows: [],
    loadingListas: false,
    errorRows: {},
    progreso: 0,
    searchingValoresHonorarios: false,
  });

  const updateLiquidaciones = (newData) => {
    setState((prev) => ({ ...prev, ...newData }));
  };

  const startLoading = (id) =>
    setState((prev) => ({
      ...prev,
      loadingRows: [...prev.loadingRows, id],
    }));

  const stopLoading = (id) =>
    setState((prev) => ({
      ...prev,
      loadingRows: prev.loadingRows.filter((x) => x !== id),
    }));

  const markRowError = (id) =>
    setState((prev) => ({
      ...prev,
      errorRows: { ...prev.errorRows, [id]: true },
    }));

  const clearRowError = (id) =>
    setState((prev) => ({
      ...prev,
      errorRows: { ...prev.errorRows, [id]: false },
    }));

  return (
    <LiquidacionesContext.Provider
      value={{
        ...state,
        updateLiquidaciones,
        startLoading,
        stopLoading,
        markRowError,
        clearRowError,
      }}
    >
      {children}
    </LiquidacionesContext.Provider>
  );
}

export function useLiquidaciones() {
  return useContext(LiquidacionesContext);
}
